import React, { useState, useEffect } from 'react';
import { Card } from 'primereact/card';
import { Checkbox } from 'primereact/checkbox';
import { timesheetApi } from "../../services";
import { useSelector } from 'react-redux';
import { selectUser } from '../../services/store/userSlice';
import { MultiSelect } from 'primereact/multiselect';

function FilterBy(props) {
    const [billable, setBillable] = useState(false);
    const [nonBillable, setNonBillable] = useState(false);
    const [selectedProjects, setSelectedProjects] = useState(null);
    const [projects, setProjects] = useState([]);
    const user = useSelector(selectUser);
    const fullURL = window.location.href;
    const url = new URL(fullURL);
    const empTimelineId = url.searchParams.get('id') || user.id;

    useEffect(() => {
        fetchAllocatedProjectData();
    }, []);

    const submitForm = () => {
        let obj = {
            projectTitle: selectedProjects,
            isBillable: billable,
            isNonBillable: nonBillable,
        };
        if (props.dateRange.startDate) obj = { ...obj, startDate: props.dateRange.startDate }
        if (props.dateRange.endDate) obj = { ...obj, endDate: props.dateRange.endDate }
        props.onFilterByChange(obj);
    };

    const fetchAllocatedProjectData = async (filter = {}) => {
        try {
            const obj = { userId: empTimelineId, ...filter };
            const resp = await timesheetApi.getProjectByUserId(obj);
            const uniqueProjects = filterUniqueProjects(resp.data.data);
            const sortedProjects = uniqueProjects.sort((a, b) => a.projectTitle.localeCompare(b.projectTitle));
            setProjects(sortedProjects);
        } catch (error) {
            console.error(error);
        }
    };

    const filterUniqueProjects = (data) => {
        const projectMap = new Map();
        Object.values(data).forEach(dayData => {
            dayData.forEach(activity => {
                const { projectTitle } = activity;
                if (!projectMap.has(projectTitle)) {
                    projectMap.set(projectTitle, activity);
                }
            });
        });
        return Array.from(projectMap.values());
    };

    return (
        props.show &&
        <Card className="card1_filter1 card123 mt-3">
            <h3 className="Filter1-By1">Filter By</h3>
            <div className="grid p-fluid">
                <div className="col-12 md:col-4">
                    <MultiSelect id="projectId" name="projectTitle" optionLabel="projectTitle"
                        placeholder="Select Projects" optionValue="projectTitle" value={selectedProjects} onChange={(e) => setSelectedProjects(e.value)}
                        options={projects} maxSelectedLabels={0} showClear={false}
                    />
                </div>
                <div className="contain md:col-2">
                    <Checkbox className="checkbox1" inputId="billable"
                        checked={billable} onChange={(e) => {
                            setBillable(e.checked);
                            if (e.checked) setNonBillable(false);
                        }}
                    />
                    <label className="p-checkbox-label timeline_label" htmlFor="billable">Billable</label>
                </div>
                <div className="contain md:col-2">
                    <Checkbox className="checkbox1" inputId="nonBillable"
                        checked={nonBillable} onChange={(e) => {
                            setNonBillable(e.checked);
                            if (e.checked) setBillable(false);
                        }}
                    />
                    <label className="p-checkbox-label timeline_label" htmlFor="nonBillable">Non-Billable</label>
                </div>
                <div className="col-12 md:col-2 mt-3">
                    <button className="round1" onClick={submitForm}> Filter </button>
                </div>
            </div>
        </Card>
    );
}

export default FilterBy;